
import angular from 'angular';
import './api/lecturefiles';

angular.module('folkeuni').factory('LectureFiles', function (LectureFilesApi, $q) {
  var lectureFiles = this;

  lectureFiles.getSasUrl = function () {
    var deferred = $q.defer();
    LectureFilesApi.getSasUrl().then(function (contractObj) {
      deferred.resolve(contractObj.data);
    }, function (errorResponse) {
      deferred.reject(errorResponse);
    });
    return deferred.promise;
  }

  lectureFiles.sendMaterial = function (sendMaterialObj) {
    var deferred = $q.defer();
    LectureFilesApi.sendMaterial(sendMaterialObj).then(function (response) {
      deferred.resolve(response.data);
    }, function (errorResponse) {
      deferred.reject(errorResponse);
    });
    return deferred.promise;
  }

  lectureFiles.uploadFileToBlob = function(url, file) {
    var deferred = $q.defer();
    LectureFilesApi.uploadFileToBlob(url, file).then(function (response) {
      deferred.resolve(response);
    }, function (errorResponse) {
      deferred.reject(errorResponse);
    });
    return deferred.promise;
  };

  return lectureFiles;
});